module.exports = "/_next/static/images/spaceship-super_aaa-rating-badge-876f314695b6909c5dbe021bead81942.svg";